import CloseIcon from '@mui/icons-material/Close'
import Box from '@mui/material/Box'
import DialogTitle, { type DialogTitleProps } from '@mui/material/DialogTitle'
import IconButton from '@mui/material/IconButton'
import Stack, { type StackProps } from '@mui/material/Stack'
import Typography, { type TypographyProps } from '@mui/material/Typography'
import { noop } from 'lodash'
import React from 'react'

type HHDialogTitleProps = DialogTitleProps & {
  title?: React.ReactNode
  icon?: React.ReactNode
  onClose?: () => void
  showCloseIcon?: boolean
  closeIconSx?: object
  TitleTypographyProps?: TypographyProps
  stackSx?: StackProps['sx']
}

const HHDialogTitle: React.FC<HHDialogTitleProps> = ({
  title,
  icon,
  onClose = noop,
  showCloseIcon = true,
  sx,
  closeIconSx,
  TitleTypographyProps,
  stackSx,
  children,
}) => (
  <DialogTitle sx={{ px: 3, py: 2, ...sx }}>
    <Stack alignItems="center" direction="row" display="inline-flex" spacing={1} sx={{ ...stackSx }}>
      {icon}
      <Typography fontWeight={600} variant="h4" {...TitleTypographyProps}>
        {title}
      </Typography>
      {children && (
        <Box flex={1} pr={4}>
          {children}
        </Box>
      )}
    </Stack>
    {showCloseIcon && (
      <IconButton
        aria-label="close"
        sx={{
          position: 'absolute',
          right: 12,
          top: 8,
          ...closeIconSx,
        }}
        onClick={onClose}
      >
        <CloseIcon />
      </IconButton>
    )}
  </DialogTitle>
)

export default HHDialogTitle
